<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'
export default {
  name: 'App',
  mounted () {
    this.init()
  },
  methods: {
    ...mapMutations([
      'SET_TIMES'
    ]),
    // 设置比例
    init () {
      this.setFontSize()
      // 窗口发生改变
      window.addEventListener('resize', async () => {
        this.setFontSize()
      })
    },
    setFontSize () {
      let clientWidth = document.body.clientWidth
      if (clientWidth < 1024) clientWidth = 1024
      if (clientWidth > 1350) clientWidth = 1350
      let times = clientWidth * 100 / 1024
      document.documentElement.style.fontSize = times + 'px'
      this.SET_TIMES(times)
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "./common/stylus/index.styl"
  #app
    width 100%
    height 100%
</style>



// WEBPACK FOOTER //
// src/App.vue